import { forwardRef, type Ref, type SVGProps } from "react";
const IconKeyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.142 2.274A1 1 0 0 1 23.83 2h5a1 1 0 0 1 1 1v5a1 1 0 0 1-.292.706l-7.951 7.97a10.001 10.001 0 1 1-6.608-6.31l1.184-1.183a1 1 0 0 1 .707-.293h2.37V6.53a1 1 0 0 1 1-1h2.4V3.18a1 1 0 0 1 .312-.726zM9.358 20.37a1.67 1.67 0 0 1 .962-.27v.05c.442.005.865.18 1.18.49a1.67 1.67 0 0 1-1.82 2.726A1.6 1.6 0 0 1 9.14 23a1.67 1.67 0 0 1 .218-2.63"
    />
  </svg>
);
const ForwardRef = forwardRef(IconKeyFilledSVG);
ForwardRef.displayName = "IconKeyFilled";
export { ForwardRef as IconKeyFilled };
